import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Challenge } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_CHALLENGE_BY_ID = 'get-challenge-by-id';

export const useGetChallengeById = (id: number) => {
  return usePermittedQuery<Challenge>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/challenge/${id}`,
    {},
    [GET_CHALLENGE_BY_ID],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
